export default "__VITE_ASSET__DNWmokSj__"